export function getSortKeyForProperty(id: string): string {
  return `property.${id}`;
}

export function getPropertyFromSortKey(sortKey: string): string {
  return sortKey.substring('property.'.length);
}
